import { Capacitor } from '@capacitor/core';

export const isNativePlatform = () => {
    // Check if running in Capacitor native environment
    if (Capacitor.isNativePlatform()) {
        return true;
    }

    // Check for "Mock Native Mode" via URL query parameter
    // This allows testing the mobile view in a browser by appending ?mode=native
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('mode') === 'native';
    }

    return false;
};
